module.exports = __webpack_public_path__ + "static/koala-blue-6f6e48166547e6d149f892535a82ed4c.png";